/* index-44 */


/* ============================================================================

   PUENTE DE COMPRA · del carrito del sitio al checkout de Shopify

   ----------------------------------------------------------------------------

   El dev dejo el enchufe puesto y vacio:



       window.SHOP = { domain: '', variants: {} };



   y su boton «Finalizar compra» ya arma el permalink oficial

   `https://TIENDA/cart/ID:CANTIDAD,...`. Aqui solo se llena.



   Lo que anade este puente sobre lo que ya habia:



     · el dominio y los 453 IDs de variante que la tienda puede cobrar hoy

     · busqueda tolerante: el carrito guarda el nombre tal como sale en la

       tarjeta y el mapa esta hecho con esos mismos nombres, pero un acento

       o una mayuscula de mas no deberian tumbar una venta

     · el aviso del desfase de precio. El catalogo trae $590 —la decision de

       Lucio para 100 ml— y la tienda solo tiene una variante a $389, que es

       la de 50 ml. No se pisa ninguno de los dos: se avisa por consola,

       porque el arreglo esta en dar de alta las dos tallas en Shopify.

     · un checkout que no se bloquea. El del dev exige que TODO el carrito

       tenga variante y, si falta una, no deja pasar nada. Con 153 productos

       sin dar de alta eso es una venta perdida por un producto: aqui se

       cobra lo que si se puede y se dice con claridad que quedo fuera.



   No modifica una linea del sitio: intercepta en fase de captura.

   ========================================================================== */

(function(){

  "use strict";

  var CX = JSON.parse(document.getElementById("pc-conexion").textContent);

  /* El precio del catalogo NO se toca. En la junta del 27 de agosto Lucio

     fijo la escalera: 50 ml a $390 y 100 ml a $590, retirando el envase de

     60 ml. El $590 del catalogo es esa decision, no un error.



     Lo que falta es del otro lado: en Shopify los 412 perfumes tienen UNA

     sola variante «Default Title» a $389, sin presentacion. Mientras no

     existan las dos tallas alla, el enlace de carrito solo puede cobrar la

     de 50 ml. Pisar el precio aqui seria deshacer en silencio lo que la

     casa decidio, asi que se deja en false y se avisa por consola. */

  /* true: manda el precio de la tienda.

     El catálogo dice $590 (100 ml, decisión de la casa) y Shopify cobra $589

     por su única variante. Enseñar $590 y cobrar $589 es exhibir un precio y

     cobrar otro. Hasta que existan las dos tallas en Shopify, se enseña lo

     que se va a cobrar. */

  var USAR_PRECIO_DE_SHOPIFY = true;



  function norm(s){

    return String(s||"").normalize("NFD").replace(/[̀-ͯ]/g,"")

      .toLowerCase().replace(/[^a-z0-9]+/g," ").trim();

  }



  /* el mapa, tambien indexado en su forma normalizada */

  var CRUDO = CX.variantes || {}, PRECIO = CX.precios || {};

  var BOLSILLO = CX.bolsillo || {};      /* nombre -> variante de 30 ml */

  var PORNORM = {}, PRECIONORM = {}, BOLSNORM = {};



  /* El indice normalizado nacio para perdonar una tilde o una mayuscula, no

     para adivinar entre dos productos distintos. En el catalogo hay siete

     pares de nombre repetido —un perfume de $589 y un ambiental de $449— y

     este atajo los confundia en las dos direcciones: cobraba el perfume por

     el ambiental, y le ponia el precio del ambiental al perfume.



     Solucion: si dos nombres distintos caen en la misma forma normalizada,

     esa forma queda AMBIGUA y se retira del indice. El atajo sigue sirviendo

     para lo que servia; lo ambiguo exige nombre exacto o no se resuelve.



     La ambiguedad se mide contra el CATALOGO, no solo contra el mapa. El

     ambiental «Aventus» fue retirado del mapa a proposito, asi que mirando

     solo el mapa parece un nombre limpio: queda «AVENTUS», el perfume, y el

     atajo los junta otra vez. Mirando el catalogo se ven los dos.

     Ver el arreglo 30 en arreglar.py. */

  var AMBIGUO = {};

  (function(){

    var visto = {};

    function mirar(k){

      var n = norm(k);

      if(visto[n] !== undefined && visto[n] !== k) AMBIGUO[n] = 1;

      visto[n] = k;

    }

    Object.keys(CRUDO).forEach(mirar);

    Object.keys(PRECIO).forEach(mirar);

    try{

      var CATALOGO = window.VELANTIS_CAT;

      if(!CATALOGO && typeof CAT !== "undefined") CATALOGO = CAT;

      if(CATALOGO && CATALOGO.length){

        for(var i = 0; i < CATALOGO.length; i++){

          var nom = CATALOGO[i] && CATALOGO[i][0];

          if(nom) mirar(nom);

        }

      }

    }catch(e){}

  })();



  Object.keys(CRUDO).forEach(function(k){

    var n = norm(k); if(!AMBIGUO[n]) PORNORM[n] = CRUDO[k];

  });

  Object.keys(PRECIO).forEach(function(k){

    var n = norm(k); if(!AMBIGUO[n]) PRECIONORM[n] = PRECIO[k];

  });

  Object.keys(BOLSILLO).forEach(function(k){

    var n = norm(k); if(!AMBIGUO[n]) BOLSNORM[n] = BOLSILLO[k];

  });



  function variante(nombre){

    if(CRUDO[nombre]) return CRUDO[nombre];

    var n = norm(nombre);

    if(PORNORM[n]) return PORNORM[n];

    /* la tarjeta de aceite se llama «Vidanta · Aceite 100 ml»: se prueba

       tambien con lo que va antes del separador */

    /* NO se parte el nombre por el separador.

       «Aventus · Aceite 1 L» se quedaba en «Aventus», que en Shopify es un

       perfume de $589, y el checkout cobraba eso por un aceite de $2,200.

       Si el nombre completo no existe, no existe: lo resuelve WhatsApp. */

    return null;

  }

  /* ---------------------------------------------------- que es perfume

     El regalo del paquete es de DOS PERFUMES. Un difusor y un aceite

     tambien suman dos cosas en el carrito, y no dan derecho a nada: la

     promocion que si les toca es el envio gratis, que no distingue. */

  var PERF = {};

  (CX.perfumes || []).forEach(function(n){ PERF[norm(n)] = 1; });



  function esPerfume(nombre){

    /* nombre EXACTO de algo que no es perfume (aromatizante, aceite): no cuenta */
    if((CX.perfumes || []).indexOf(nombre) < 0 && CX.precios && CX.precios[nombre] != null) return false;
    if(PERF[norm(nombre)]) return true;

    return !!PERF[norm(String(nombre).split("\u00b7")[0])];

  }



  /* REGLA_BOLSILLO (3-sep-2026). Un frasco de bolsillo por cada 2 perfumes
     de 100 ml o por cada 3 de 50 ml; no se mezclan. Cuenta solo perfumes
     (ni ambientales, ni aceites, ni difusores, ni el propio regalo). */
  function contarTallas(items){
    var n100 = 0, n50 = 0;
    (items || []).forEach(function(it){
      if(!it || !esPerfume(it.name)) return;
      if(String(it.name).indexOf(MARCA_REGALO) === 0) return;
      var q = Math.max(1, parseInt(it.qty, 10) || 1);
      if(String(it.talla) === "50") n50 += q; else n100 += q;
    });
    return {n100:n100, n50:n50, ganados: (window.VELANTIS_OFFERS && window.VELANTIS_OFFERS.gift30Enabled === true) ? Math.floor(n100 / 2) + Math.floor(n50 / 3) : 0};
  }
  /* cuanto falta para el siguiente frasco, dicho en llano */
  function fraseFalta(c){
    var f100 = 2 - (c.n100 % 2), f50 = 3 - (c.n50 % 3);
    if(c.n100 % 2 === 1) return "Elige 1 m\u00e1s de 100 ml";
    if(c.n50 % 3 === 2) return "Elige 1 m\u00e1s de 50 ml";
    if(c.n50 % 3 === 1) return "Elige 2 m\u00e1s de 50 ml";
    return "Elige 2 de 100 ml o 3 de 50 ml";
  }
  function bolsillo(nombre){

    if(BOLSILLO[nombre]) return BOLSILLO[nombre];

    var n = norm(nombre);

    return BOLSNORM[n] || null;

  }

  /* EL PRECIO QUE VIAJA AL CHAT ES EL QUE SE VIO EN LA PAGINA.



     Primero el del carrito —el sitio guarda el precio de la tarjeta al

     anadir—, y si faltara, el `data-price` de la propia tarjeta. NUNCA el

     de Shopify: la tienda arrastra $589 y la casa fijo $590, y aqui no hay

     checkout que obligue a decir el de la tienda. Lo que se manda es una

     cotizacion que una persona confirma; el numero bueno es el de la casa.



     En modo carrito esto no se usa: alli manda el checkout y el precio

     tiene que ser el suyo. */

  function precioDeLaPagina(it){

    /* El CERO es un precio: es el del frasco de bolsillo de regalo. Con

       `+it.price` a secas se leia como falso, el renglon salia sin precio

       y se llevaba por delante el total y la linea del envio del mensaje. */

    if(it && it.price != null && !isNaN(+it.price)) return +it.price;

    var n = String((it && it.name) || "").replace(/"/g, "");

    var el = document.querySelector('[data-name="' + n + '"][data-price]');

    if(el && +el.dataset.price) return +el.dataset.price;

    return precioReal(it && it.name);

  }



  function precioReal(nombre){

    /* La clave EXACTA manda. Antes se iba directo al indice normalizado, y

       ahi «SANTAL 33» (perfume, $589) recibia el precio de «Santal 33»

       (ambiental, $449) por ser el ultimo escrito. */

    if(PRECIO[nombre] != null) return PRECIO[nombre];

    var n = norm(nombre);

    if(PRECIONORM[n] != null) return PRECIONORM[n];

    /* NO se prueba con lo que va antes del «·»: ese atajo es el que cobraba

       un perfume por un aceite. Si no hay nombre exacto, no hay precio. */

    return null;

  }



  /* --------------------------------------------------- se llena el enchufe */

  window.SHOP = window.SHOP || {};

  SHOP.domain = CX.dominio;

  SHOP.variants = new Proxy({}, {

    get: function(_, k){ return typeof k === "string" ? variante(k) : undefined; },

    has: function(_, k){ return typeof k === "string" && !!variante(k); }

  });



  /* ------------------------------------------------- el precio de la caja

     Se corrige el `data-price` de cada tarjeta ANTES de que el carrito lo

     lea, que es en el click. Se repasa cada vez que el sitio repinta. */

  function corregirPrecios(){

    if(!USAR_PRECIO_DE_SHOPIFY) return;

    var v = document.querySelectorAll("[data-name][data-price]");

    for(var i=0;i<v.length;i++){

      var el = v[i];

      if(el.dataset.pcPrecio === el.dataset.name) continue;

      /* NO es perfume: su precio no sale del catalogo de perfumes. */

      var _m = String(el.dataset.img || "");

      var _s = String(el.dataset.sub || "");

      var esAmb = /^n-amb/.test(_m) || _m === "amb-img" || /^AMB:/.test(String(el.dataset.lhs || "")) || /aroma de ambiente/i.test(_s);
      var esDif = !esAmb && /difusor/i.test(_s) && !/aceite/i.test(_s);
      var esAce = !esAmb && !esDif && (_m === "oil-ph" || /aceite/i.test(_s));
      if(!esAmb && !esDif && !esAce && /difusor/i.test(_s)) continue;
      /* 4-sep: el ambiental SI toma su precio del mapa, pero solo por nombre
         EXACTO (sin normalizar: «Santal 33» no debe heredar el $589 de «SANTAL 33»). */
      var p = (esAmb || esDif || esAce) ? (PRECIO[el.dataset.name] != null ? PRECIO[el.dataset.name] : null) : precioReal(el.dataset.name);

      if(p == null) continue;

      el.dataset.pcPrecio = el.dataset.name;

      if(+el.dataset.price === p) continue;

      el.dataset.price = p;

      /* y lo que se lee en la tarjeta */

      var t = el.querySelector(".cat-price, .oil-price, .card-price, .dif-card-price, .pp-simbody .pr, .nz-price, .price"); /* 4-sep: + difusor, similares, novedades */

      /* 4-sep: si la tarjeta ya trae los dos precios, solo se toca el de 100 ml;
         antes se reemplazaba el primer «$» y pisaba el de 50 ml. */
      if(t && t.getAttribute("data-2p") === "1"){ var b100 = t.querySelector(".pz-100 b"); if(b100) b100.textContent = "$" + p.toLocaleString("es-MX"); }
      else if(t) t.innerHTML = t.innerHTML.replace(/\$\s?[\d,]+/, "$" + p.toLocaleString("es-MX"));

    }

  }



  /* PAQUETE-SANTAL33 */
  /* Paquete Santal 33 (15-sep-2026, direccion): el aromatizante Santal 33 lleva un frasco de
     30 ml del perfume Santal 33 dentro de la caja y la mitad del envio. Un frasco por ritual.
     Se genera con PROMOS/paquete_santal33.py; no se edita a mano. */
  var PAQUETE = {"aromatizante": "Paquete Santal 33", "variante": "54919155679456", "precio": 550, "fotoNombre": "Santal 33", "regalo": "SANTAL 33", "regaloVar": "54656243433696", "codigo": "", "obsequio": "Elixir de Parfum 30 ml · Santal 33", "subObsequio": "Obsequio de la casa · Paquete Santal 33", "cpCiudad": "", "cpDesde": 0, "cpHasta": 0};
  window.VELANTIS_PAQUETE = PAQUETE;
  function paquetes(items){
    var n = 0;
    (items || []).forEach(function(it){ if(it && it.name === PAQUETE.aromatizante) n += Math.max(1, parseInt(it.qty, 10) || 1); });
    return Math.min(20, n);
  }
  function regaloPaquete(){ return (CX.bolsillo && CX.bolsillo[PAQUETE.regalo]) || PAQUETE.regaloVar; }
  /* el codigo del envio solo viaja por debajo del piso del envio gratis */
  function sumaItems(items){ var t = 0; (items || []).forEach(function(it){ t += (+it.price || 0) * (parseInt(it.qty, 10) || 1); }); return t; }
  /* copy de lujo: paquete, obsequio de la casa, envio incluido; nada de «gratis» ni «regalo» */
  function avisoPaquete(n){ return '<b style="color:#8a6d1f;letter-spacing:.08em;text-transform:uppercase;font-size:11.5px">Paquete Santal 33</b><br>' +
    (n > 1 ? 'Tus ' + n + ' Elixir de Parfum de 30 ml van' : 'Tu Elixir de Parfum de 30 ml va') + ' incluido en tu paquete, ' +
    'con el envío incluido.'; }
  function textoWhatsPaquete(n){ return 'Paquete Santal 33: ' + n + ' Elixir de Parfum de 30 ml como obsequio de la casa'; }

  /* ------------------------------------------------------- el checkout */

  function pesos(n){ return "$" + Number(n).toLocaleString("es-MX"); }



  function alPagar(e){

    var go = e.target.closest("#cartGo");

    if(!go) return;

    var items = [];

    try{ items = JSON.parse(localStorage.getItem("velantis-cart")) || []; }

    catch(err){ items = []; }

    if(!items.length) return;
    items = items.filter(function(it){ return !(it && it.name === PAQUETE.obsequio); });



    e.preventDefault();

    e.stopImmediatePropagation();      // el manejador del dev no corre



    var van = [], fuera = [];
    var cuentaPago = contarTallas(items), regalosPuestos = 0;
    items.forEach(function(it){
      var id;
      if(String(it.name).indexOf(MARCA_REGALO) === 0){
        /* el frasco de regalo: solo los ganados, por su variante de 30 ml */
        if(regalosPuestos >= cuentaPago.ganados) return;
        id = bolsillo(String(it.name).slice(MARCA_REGALO.length));
        if(id){ regalosPuestos++; van.push(id + ":1"); }
        return;
      }
      id = (it.talla==='50') ? (window.vPres ? window.vPres.id50(it.name) : null) : variante(it.name);

      if(id) van.push(id + ":" + Math.min(20, Math.max(1, parseInt(it.qty, 10) || 1)));

      else fuera.push(it.name);

    });



    var nota = document.getElementById("cartNote");

    if(!van.length && CX.modo !== "whatsapp"){

      if(nota) nota.textContent =

        "Estos aromas todavía no se pueden pagar en línea. Escríbenos y te los "

        + "apartamos en tienda.";

      return;

    }

    /* Si algo del carrito no se puede cobrar, NO se continúa.

       Antes se seguía y se descartaba: cuatro perfumes en pantalla, uno en el

       pedido. El aviso existía, pero iba en gris de 11.5 px debajo del botón y

       el navegador se iba igual a los 1.8 s.



       Ahora se para, se dice qué falta, y se ofrece la salida real: apartarlo

       por WhatsApp. Quien quiera pagar solo lo disponible, quita lo otro. */

    if(fuera.length && CX.modo !== "whatsapp"){

      if(nota){

        nota.innerHTML =

          "<b>No podemos cobrar en línea " + vEsc(fuera.slice(0,2).join(", "))

          + (fuera.length > 2 ? " y " + (fuera.length - 2) + " más" : "")

          + ".</b><br>Quítalo del carrito para pagar el resto."; /* 5-sep: sin apartado por WhatsApp */

        nota.style.color = "";

        nota.style.fontSize = "13px";

        nota.style.lineHeight = "1.55";

      }

      return;

    }

    /* ============================================================

       EL FRASCO DE BOLSILLO DEL PAQUETE



       Llevando dos o mas PERFUMES entra un frasco de 30 ml de regalo, y

       tiene que ser de una de las fragancias que se lleva —esa condicion

       es la promocion, no un detalle—.



       Solo cuentan los perfumes. Un aceite y un ambiental tambien suman

       dos renglones en el carrito y no arman paquete; a ellos les toca el

       envio gratis, que no distingue de que familia es cada cosa.



       Se resuelve aqui porque es el unico sitio que sabe cuales son.

       Shopify no puede: sus descuentos cuentan productos, no distinguen

       familias ni saben que el regalo tenga que ser de uno de ellos.



       Por el CHAT el regalo se puede cumplir hoy —lo prepara la casa a

       mano—, asi que ahi va siempre. Por el carrito hace falta ademas que

       el producto de 30 ml exista en la tienda; mientras no este,

       `bolsillo()` devuelve nulo y no se promete un renglon que el

       checkout no podria ensenar. */

    var perfumes = items.filter(function(it){ return esPerfume(it.name) && String(it.name).indexOf(MARCA_REGALO) !== 0; });
    var cuantos = cuentaPago.ganados >= 1 ? 2 : 0; /* la regla ya se conto por tallas */
    /* si la persona ya escogio su frasco en el carrito, ese manda: no se

       vuelve a poner uno decidido por el codigo */

    var yaElegido = items.filter(function(it){

      return String(it.name).indexOf(MARCA_REGALO) === 0; })[0];



    var regalo = null;

    if(yaElegido){

      regalo = null;                      /* ya viaja como renglon */

    }else if(cuantos >= 2){

      if(CX.modo === "whatsapp"){

        regalo = {id:null, de:perfumes[0].name};

      }else if(PROMOS.bolsillo30){

        for(var r = 0; r < perfumes.length && !regalo; r++){

          var b = bolsillo(perfumes[r].name);

          if(b) regalo = {id:b, de:perfumes[r].name};

        }

      }

    }

    /* 15-sep-2026 (la casa, pedido #1083): el frasco de bolsillo SE ELIGE. Antes, si no elegia,
       el codigo ponia el del primer perfume y nadie sabia que queria. Ahora, si gano frasco y no lo
       eligio, no se va a pagar: salta la alerta y se abre la eleccion en el carrito. */
    var puedeRegalo = perfumes.some(function(it){ return !!bolsillo(it.name); });
    if(cuentaPago.ganados > regalosPuestos && puedeRegalo && PROMOS.bolsillo30 && CX.modo !== "whatsapp"){
      regaloAbierto = true;
      try{ pintarRegalo(); }catch(errR){}
      var cajaR = document.getElementById("pcRegalo");
      if(cajaR){
        cajaR.style.outline = "2px solid #7F2A4E"; cajaR.style.outlineOffset = "2px";
        try{ cajaR.scrollIntoView({block: "center", behavior: "smooth"}); }catch(errS){}
      }
      if(nota){
        nota.innerHTML = "<b>Te ganaste " + (cuentaPago.ganados - regalosPuestos > 1 ? (cuentaPago.ganados - regalosPuestos) + " frascos" : "un frasco") +
          " de bolsillo de 30 ml.</b><br>Elige de cu\u00e1l fragancia lo quieres para continuar con tu pedido.";
        nota.style.color = "#7F2A4E"; nota.style.fontSize = "13px"; nota.style.lineHeight = "1.55";
      }
      window.alert("Te ganaste un frasco de bolsillo de 30 ml. Elige de cu\u00e1l fragancia lo quieres para continuar con tu pedido.");
      return;
    }
    if(regalo && regalo.id){
      van.push(regalo.id + ":1");

      if(nota) nota.textContent = "Va incluido el frasco de bolsillo de 30 ml de "

        + regalo.de + ". " + (nota.textContent || "");

    }



    /* ============================================================

       MODO WHATSAPP



       Cuando la tienda no va a cobrar en linea, el boton no manda al

       checkout: manda el pedido al chat, escrito como una lista para que

       del otro lado solo haya que confirmar.



       Se ensena lo que la caja cobraria de cada cosa, no el precio de la

       tarjeta: la tarjeta trae el del catalogo y en el chat hay una

       persona que va a cotizar de verdad.

       ============================================================ */

    if(CX.modo === "whatsapp"){

      var S = String.fromCharCode(10);

      var lista = ["Hola, vengo de la p\u00e1gina. Quiero:", ""];

      var suma = 0, hayPrecio = true;

      items.forEach(function(it){

        /* El precio sale del CARRITO, que es el de la tarjeta que la

           persona miro —$590—, y no el de la tienda —$589—. Aqui no hay

           checkout que contradiga a la pagina: lo que se manda es una

           cotizacion que se confirma en el chat, y el numero bueno es el

           que fijo la casa. */

        var pr = precioDeLaPagina(it);

        var q = it.qty || 1;

        if(pr == null) hayPrecio = false; else suma += pr * q;

        lista.push("\u2022 " + it.name + (q > 1 ? " \u00d7 " + q : "") +

                   (pr == null ? ""

                    : pr === 0 ? " \u2014 incluido"

                    : " \u2014 " + pesos(pr * q)));

      });

      if(regalo){

        lista.push("\u2022 Frasco de bolsillo 30 ml de " + regalo.de +

                   " \u2014 incluido por llevar dos perfumes");

      }

      if(hayPrecio){

        lista.push("");

        if(paquetes(items)) lista.push(textoWhatsPaquete(paquetes(items))); lista.push("Total: " + pesos(suma));

        var falta = (CX.envio || 0) - suma;

        lista.push(falta <= 0

          ? "Env\u00edo gratis incluido."

          : "Faltan " + pesos(falta) + " para el env\u00edo gratis.");

      }

      window.open(CX.wa + "?text=" + encodeURIComponent(lista.join(S)),

                  "_blank", "noopener");

      return;

    }



    /* paquete Santal 33: un frasco de 30 ml por aromatizante, y el codigo de envio gratis */
    var nPaq = paquetes(items);
    /* misma variante dos veces (frasco de bolsillo de SANTAL 33 + obsequio del ritual): se suman */
    var juntas = {}, ordenIds = [];
    van.forEach(function(p){ var x = String(p).split(":"); if(!(x[0] in juntas)){ juntas[x[0]] = 0; ordenIds.push(x[0]); } juntas[x[0]] += parseInt(x[1], 10) || 1; });
    van = ordenIds.map(function(id){ return id + ":" + Math.min(40, juntas[id]); });
    var url = "https://" + CX.dominio + "/cart/" + van.join(",") +
      (nPaq && PAQUETE.codigo && sumaItems(items) < (CX.envio || 999) ? "?discount=" + encodeURIComponent(PAQUETE.codigo) : "");

    setTimeout(function(){ window.location.href = url; }, fuera.length ? 1800 : 0);

  }



  /* ================================================================

     LAS PROMOCIONES QUE LA CAJA NO CONOCE



     El sitio anuncia cinco promociones. Shopify no tiene ninguna dada de

     alta, asi que la clienta las lee en la pagina y no se le aplican al

     pagar. De las cinco, la casa solo confirmo el envio gratis:



       envio gratis a partir de $1,200 ......... CONFIRMADO (Lucio)

       relanzamiento: 2 perfumes + 30 ml ....... "todavia no meterlo"

       3x2 y 4x3 ............................... nunca se definio

       difusor + 100 ml de aceite gratis ....... nunca se definio

       $2,500 -> 10% OFF ....................... nunca se definio



     Se apagan las cuatro sin confirmar. No es un juicio de diseno: una

     promesa que la caja no cumple es la peor forma de perder a alguien

     que ya habia decidido comprar. Cuando la casa las cree en Shopify se

     encienden aqui cambiando el false por true.

     ================================================================ */

  var PROMOS = {

    envioGratis:  true,    // $1,200 · confirmado

    relanzamiento: (window.VELANTIS_OFFERS && window.VELANTIS_OFFERS.gift30Enabled === true),  // 3-sep: ENCENDIDA (frasco de bolsillo)  // 2 perfumes + uno de 30 ml

    multiplos:    false,   // 3x2 y 4x3

    difusor:      false,   // difusor + 100 ml de aceite

    nivel2500:    false,   // $2,500 -> 10% OFF



    /* EL FRASCO DE BOLSILLO. Aqui hace falta una tercera cosa ademas de

       los 462 productos de 30 ml y del descuento automatico: que el sitio

       distinga TALLAS.



       El paquete es dos de CIEN mililitros, y el carrito de este sitio

       guarda solo el nombre de la fragancia —no la presentacion—, asi que

       hoy no puede saber si alguien se lleva dos de 100 o dos de 50.

       Encenderlo ahora seria regalar un frasco en compras que no dan

       derecho a el.



       En la landing si funciona, porque alli la talla se elige de forma

       explicita antes de armar el carrito. */

    bolsillo30: (window.VELANTIS_OFFERS && window.VELANTIS_OFFERS.gift30Enabled === true)

  };
  window.VELANTIS_PROMOS = PROMOS; /* para el boton de la ficha, que vive en otro bloque */



  /* ================================================================

     LAS RESENAS INVENTADAS



     La ficha pinta esto en las 591 fragancias, con los mismos numeros

     fijos en todas:



         ★★★★★ 4.9   (340 resenas)   +500 vendidos

         Pocas unidades · quedan 6



     No sale de ningun lado: son constantes en el codigo. La tienda tiene

     Judge.me instalado y funcionando, y hoy dice «Se el primero en

     escribir una resena» —cero resenas—.



     Publicar prueba social fabricada es publicidad enganosa (LFPC art.

     32) y va contra los terminos de Shopify y de Judge.me. Se apaga hasta

     que haya resenas de verdad que ensenar; entonces se conecta la API de

     Judge.me y las estrellas dicen lo que digan los clientes.

     ================================================================ */

  var RESENAS_REALES = false;   // true cuando Judge.me tenga resenas



  var APAGAR = [];

  if(!RESENAS_REALES) APAGAR.push("pvSocial", "pvUrgency", "ppSocial",

                                  "ppRating", "ppUrgency");



  /* El carrusel de video de la ficha pide 16 archivos de

     «VELANTIS PAGINA WEB/resenas/». Ninguno vino en la entrega —esa carpeta

     no existe en el zip—, asi que en cada ficha se veia el titulo «Resenas

     verificadas» sobre un reproductor en negro y unas cajas grises.

     Se oculta la seccion entera, titulo incluido, hasta que lleguen los

     videos. Son reales: los grabaron clientas. Solo faltan los archivos. */

  /* Los ocho videos de resena SI son reales —los grabaron clientas— y si

     existen: viven en 00-insumos/VELANTIS PAGINA WEB/resenas/, no dentro de

     la entrega del dev, y por eso salian rotos. Corregida la ruta, el

     carrusel se queda encendido. Lo que sigue apagado son las estrellas y

     el conteo inventados, que es otra cosa. */

  var VIDEOS_REALES = true;



  function apagarVideos(){

    if(VIDEOS_REALES) return;

    var c = document.getElementById("ppVideos");

    if(!c || c.dataset.pcApagado) return;

    var seccion = c.closest(".pp-section") || c.parentNode;

    if(seccion){ seccion.style.display = "none"; c.dataset.pcApagado = "1"; }

  }

  /* `cartRelanz` es el banner dentro del carrito que promete el frasco de

     30 ml. Pertenece a esta promocion, y estaba fuera de la lista: el selector

     del regalo se apagaba y el banner seguia prometiendolo. La persona leia

     "llevate 2 y te regalamos" y no encontraba donde elegir.



     Ademas ese banner es un enlace a #/best-sellers, que hoy tiene CERO

     productos, y al tocarlo cierra el carrito. */

  if(!PROMOS.relanzamiento) APAGAR.push("promoStrip", "promoToast", "promoToastX",

                                        "cartRelanz");

  if(!PROMOS.multiplos)     APAGAR.push("cartPromo", "cartGift", "cartDifGift");

  if(!PROMOS.difusor)       APAGAR.push("lhsGiftBtn", "lhsGiftNote",

                                        "oilGiftBanner", "dgiftToast", "dgiftX");

  /* `clT2` era solo la marca del escalon. El MENSAJE seguia vivo diciendo

     "te faltan $140 para 10% OFF", empujando a agregar otro perfume por un

     descuento que Shopify no tiene dado de alta. */

  if(!PROMOS.nivel2500)     APAGAR.push("clT2", "clMsg");



  function apagarPromos(){

    if(!APAGAR.length) return;

    for(var i = 0; i < APAGAR.length; i++){

      var el = document.getElementById(APAGAR[i]);

      if(el && !el.dataset.pcApagado){

        el.dataset.pcApagado = "1";

        el.hidden = true;

        el.style.display = "none";

      }

    }

  }

  /* la barra corre sola y el sitio la vuelve a montar al cambiar de ruta */

  var estilo = document.createElement("style");

  estilo.textContent = APAGAR.map(function(id){

    return "#" + id + "{display:none!important}"; }).join("")

    + (RESENAS_REALES ? "" :

       /* las estrellas y el conteo viven en spans sin id propio */

       ".pv-stars,.pv-rating-num,.pv-reviews,.pv-sold,"

       + ".pp-stars,.pp-rating-num,.pp-reviews,.vhero-rating,"

       + ".stars{display:none!important}");

  document.head.appendChild(estilo);

  /* ------------------------------------------------- el boton dice la verdad

     En modo chat el boton seguia diciendo «Finalizar compra» y abria

     WhatsApp. Quien lo pulsa espera una caja: la pagina tiene que decir a

     donde lleva antes de llevar, no despues. El sitio repinta el carrito al

     anadir y al quitar, asi que se vuelve a poner en cada repintado. */

  function ponerBoton(){

    if(CX.modo !== "whatsapp") return;

    var b = document.getElementById("cartGo");

    if(!b || b.dataset.pcTexto) return;

    b.dataset.pcTexto = "1";

    b.textContent = "Pedir por WhatsApp";

    var pie = document.getElementById("cartShip");

    if(pie) pie.textContent =

      "Envíos a todo México · te confirmamos el pedido por WhatsApp";

  }



  /* ==================================================================

     EL FRASCO DE BOLSILLO SE ELIGE, NO SE SUPONE



     En cuanto hay dos perfumes en el carrito aparece un bloque con hasta

     cuatro opciones: los dos que se lleva y la pareja de layering de cada

     uno. Las parejas son sugerencias —«prueba este con el que ya

     tienes»— y salen solo si existen: si una de las dos fragancias no

     tiene pareja calculada, se ensena una sola.



     Antes el regalo lo decidia el codigo, el primer perfume de la lista,

     y viajaba en el mensaje sin que nadie lo hubiera escogido. Regalar

     algo sin preguntar de que sabor es la forma mas rapida de que el

     regalo no le sirva a nadie.

     ================================================================== */

  var PAREJAS = CX.parejas || {};

  var MARCA_REGALO = "Bolsillo 30 ml \u00b7 ";



  function estiloRegalo(){

    if(document.getElementById("pc-estilo-regalo")) return;

    var s = document.createElement("style");

    s.id = "pc-estilo-regalo";

    /* Compacto a proposito. La version anterior traia titulo, parrafo y

       cuatro opciones siempre abiertas, y en un carrito con varias cosas

       tapaba justo lo que se venia a mirar. Un renglon que se abre al

       tocarlo dice lo mismo y no estorba. */

    s.textContent =

      ".pc-regalo{margin:8px 0 2px;border-radius:11px;" +

      "border:1px solid rgba(212,175,55,.45);background:rgba(212,175,55,.09)}" +

      ".pc-regalo .cab{display:flex;align-items:center;gap:8px;width:100%;" +

      "padding:9px 11px;background:none;border:0;cursor:pointer;" +

      "font-family:inherit;font-size:13px;line-height:1.3;text-align:left;" +

      "color:#191F31}" +

      ".pc-regalo .cab .ic{flex:none;font-size:14px}" +

      ".pc-regalo .cab .qu{flex:1 1 auto;min-width:0;overflow:hidden;" +

      "text-overflow:ellipsis;white-space:nowrap}" +

      ".pc-regalo .cab .qu b{font-weight:700}" +

      ".pc-regalo .cab .cual{color:#8a6d1f;font-weight:700}" +

      ".pc-regalo .cab .accion{flex:none;color:#8a6d1f;font-weight:700;" +

      "font-size:12px;text-decoration:underline}" +

      ".pc-regalo .ops{display:grid;gap:5px;padding:0 9px 9px}" +

      ".pc-regalo .ops[hidden]{display:none}" +

      /* CONTRASTE. Iban en blanco translucido sobre el crema del panel y

         sobre el dorado del bloque: el borde casi no se veia y el nombre

         de la fragancia se leia a media tinta. Ahora el fondo es blanco

         opaco, el borde tiene cuerpo y el texto va en la tinta de la

         marca, no heredado. */

      ".pc-regalo button.op{display:flex;justify-content:space-between;" +

      "align-items:baseline;gap:9px;width:100%;text-align:left;" +

      "padding:8px 11px;border-radius:8px;cursor:pointer;" +

      "font-family:inherit;font-size:13px;font-weight:600;line-height:1.25;" +

      "color:#191F31;background:#fff;border:1px solid rgba(25,31,49,.28);" +

      "box-shadow:0 1px 2px rgba(25,31,49,.08)}" +

      ".pc-regalo button.op:hover,.pc-regalo button.op:focus-visible{" +

      "border-color:#8a6d1f;background:#FFF7E0;" +

      "box-shadow:0 2px 8px rgba(138,109,31,.24)}" +

      ".pc-regalo button.op em{font-style:normal;font-size:10.5px;" +

      "letter-spacing:.1em;text-transform:uppercase;flex:none;" +

      "font-weight:700;color:#8a6d1f}" +

      /* REGALO-VISIBLE */
      /* EL ELEGIDO SE VE. Antes la lista quedaba igual despues de tocar
         una opcion y el unico rastro era un renglon mas arriba, casi
         siempre fuera de la vista. Ahora el elegido lleva palomita,
         fondo dorado y la palabra "elegido" donde iba su papel. */
      ".pc-regalo button.op.sel{border-color:#8a6d1f;background:#FFF3D0;" +
      "box-shadow:inset 0 0 0 1px #8a6d1f}" +
      ".pc-regalo button.op.sel>span:before{content:'\\2713';display:inline-block;" +
      "margin-right:7px;font-weight:800;color:#8a6d1f}" +
      ".pc-regalo button.op.sel em{color:#191F31}" +
      /* la cuenta va en un segundo renglon: cuantos llevas y cual */
      ".pc-regalo .cab .qu{white-space:normal;overflow:visible;text-overflow:clip}" +
      ".pc-regalo .cuenta{display:block;margin-top:2px;font-size:11px;" +
      "font-weight:600;color:#8a6d1f}";

    document.head.appendChild(s);

  }



  function leerCarrito(){

    try{ return JSON.parse(localStorage.getItem("velantis-cart")) || []; }

    catch(e){ return []; }

  }



  /* si estaba abierto, se queda abierto al repintar */

  var regaloAbierto = false, regaloTocado = false;



  /* PINTAR-PAQUETE */
  /* Ritual Santal 33 en el carrito (15-sep-2026, la casa: «deberia estar integrado como en las promos
     de 3 de 50 ml o 2 de 100 ml»). El Elixir de Parfum de 30 ml entra como PIEZA del carrito, a $0 y
     con su leyenda, justo debajo del aromatizante. Su cantidad sigue sola a la de aromatizantes: si se
     quita o se cambia a mano, aqui se vuelve a poner. Al pagar ese renglon no se cobra por nombre:
     el checkout pone la variante de 30 ml por cada aromatizante (ver alPagar). */
  function pintarPaquete(){
    var viejo = document.getElementById("pcPaquete");
    if(viejo && viejo.parentNode) viejo.parentNode.removeChild(viejo);
    var items = leerCarrito(), n = paquetes(items), puestos = 0, filas = 0, i0 = -1;
    items.forEach(function(it, i){
      if(!it) return;
      if(it.name === PAQUETE.obsequio){ filas++; puestos += Math.max(1, parseInt(it.qty, 10) || 1); }
      if(i0 < 0 && it.name === PAQUETE.aromatizante) i0 = i;
    });
    /* fotos reales en el carrito: clases paq-aro / paq-obs, las pinta la seccion del ritual */
    var enSuLugar = filas === 1 && items[i0 + 1] && items[i0 + 1].name === PAQUETE.obsequio && items[i0 + 1].img === "n-amaderados paq-obs" && items[i0].img === "n-amb paq-aro";
    if(n === puestos && (n === 0 || enSuLugar)) return;
    var sin = items.filter(function(it){ return !(it && it.name === PAQUETE.obsequio); });
    if(n){
      var pos = -1;
      sin.forEach(function(it, i){ if(pos < 0 && it && it.name === PAQUETE.aromatizante) pos = i; });
      sin.splice(pos + 1, 0, {name: PAQUETE.obsequio, price: 0, img: "n-amaderados paq-obs", sub: PAQUETE.subObsequio, qty: n, talla: "100"});
      if(pos >= 0) sin[pos].img = "n-amb paq-aro";
    }
    try{ localStorage.setItem("velantis-cart", JSON.stringify(sin)); }catch(e){ return; }
    if(window.VelantisCart && window.VelantisCart.recargar) window.VelantisCart.recargar();
  }

  function pintarRegalo(){

    var caja = document.getElementById("cartItems");

    if(!caja) return;



    /* La promo del frasco de bolsillo esta apagada (PROMOS.relanzamiento):

       no existe en Shopify. Antes esta funcion la ofrecia igual y metia al

       carrito un renglon que la caja no puede cobrar, con lo que el boton de

       pagar se bloqueaba para TODO el pedido. Ver el arreglo 32.



       Se retira tambien cualquier renglon de regalo que hubiera quedado

       guardado de antes, o el carrito seguiria trabado al recargar. */

    if(typeof PROMOS === "undefined" || !PROMOS.relanzamiento){

      var viejo = document.getElementById("pcRegalo");

      if(viejo && viejo.parentNode) viejo.parentNode.removeChild(viejo);

      try{

        var guardado = JSON.parse(localStorage.getItem("velantis-cart")) || [];

        var limpio = guardado.filter(function(it){

          return String(it && it.name || "").indexOf(MARCA_REGALO) !== 0;

        });

        if(limpio.length !== guardado.length){

          localStorage.setItem("velantis-cart", JSON.stringify(limpio));

          if(window.VelantisCart && window.VelantisCart.recargar)

            window.VelantisCart.recargar();

        }

      }catch(e){}

      return;

    }

    var previo = document.getElementById("pcRegalo");

    var items = leerCarrito();
    /* El observador llama a esta funcion tras CADA cambio del DOM, y pintar
       es un cambio del DOM: sin esta firma se repintaba sin parar y el
       boton «elegir» nunca se quedaba quieto. Mismo carrito y mismo estado,
       misma firma: no se toca nada. */
    var firma = JSON.stringify([items.map(function(it){ return [it.name, it.talla || "100", it.qty || 1]; }), !!regaloAbierto]);
    if(previo && previo.dataset.firma === firma) return;



    var perfumes = items.filter(function(it){ return esPerfume(it.name) && String(it.name).indexOf(MARCA_REGALO) !== 0; });
    var cuenta = contarTallas(items);
    var puestos = items.filter(function(it){ return String(it.name).indexOf(MARCA_REGALO) === 0; });

    /* mas regalos puestos que ganados (quitaron un perfume): sobran renglones */
    if(puestos.length > cuenta.ganados){
      try{
        var quitar = puestos.length - cuenta.ganados, quedan = [];
        items.slice().reverse().forEach(function(it){
          if(quitar > 0 && String(it.name).indexOf(MARCA_REGALO) === 0){ quitar--; return; }
          quedan.unshift(it);
        });
        localStorage.setItem("velantis-cart", JSON.stringify(quedan));
        if(window.VelantisCart && window.VelantisCart.recargar) window.VelantisCart.recargar();
      }catch(e){}
      return;
    }

    estiloRegalo();
    if(!previo){
      previo = document.createElement("div");
      previo.className = "pc-regalo";
      previo.id = "pcRegalo";
      caja.parentNode.insertBefore(previo, caja.nextSibling);
    }
    previo.dataset.firma = firma;

    /* todavia no alcanza: se dice cuanto falta, y nada mas */
    if(!cuenta.ganados){
      if(!perfumes.length){ previo.parentNode.removeChild(previo); return; }
      regaloAbierto = false;
      previo.className = "pc-regalo pista";
      previo.innerHTML = '<div class="cab"><span class="ic">\ud83c\udf81</span><span class="qu">' +
        vEsc(fraseFalta(cuenta)) + ' y lleva tu esencia a todos lados con una versi\u00f3n de bolsillo (30 ml) de alguno de los que llevas</span></div>';
      previo.dataset.ops = "[]";
      return;
    }
    previo.className = "pc-regalo";

    /* YA ESTAN TODOS: el resumen, cerrado. Si lo abren, se ve la lista
       entera con los elegidos marcados, para cambiar UNO sin perder el otro
       (antes "cambiar" los borraba todos). */
    /* LA PRIMERA VEZ, ABIERTA. Cerrada detras de la palabra "elegir"
       parecia un aviso y casi nadie descubria que se podia elegir. Se abre
       sola cuando la promocion se gana y todavia no hay ninguno elegido;
       despues manda el cliente. */
    if(!regaloTocado && !puestos.length) regaloAbierto = true;
    var yaN = puestos.map(function(p){ return p.name.slice(MARCA_REGALO.length); });
    var falta = cuenta.ganados - puestos.length;
    var yaPuesto = {};
    yaN.forEach(function(n){ yaPuesto[n] = 1; });
    if(puestos.length >= cuenta.ganados && !regaloAbierto){
      previo.innerHTML =
        '<div class="cab"><span class="ic">\ud83c\udf81</span>' +
        '<span class="qu">' + (puestos.length > 1 ? 'Tus frascos de bolsillo 30 ml \u00b7 ' : 'Bolsillo 30 ml \u00b7 ') +
        '<span class="cual">' + yaN.map(vEsc).join(", ") + '</span></span>' +
        '<button class="accion cambiar" type="button" data-cambiar="1">cambiar</button></div>';
      return;
    }



    /* los dos que se lleva, y la pareja de cada uno */

    var ops = [], visto = {};

    perfumes.forEach(function(it){
      if(visto[it.name]) return;
      visto[it.name] = 1;
      ops.push({n:it.name, rol:"versión de bolsillo"});
    });
    perfumes.forEach(function(it){
      var par = PAREJAS[it.name];
      if(par && !bolsillo(par)) par = null; /* la pareja debe tener frasco de 30 ml */

      if(!par || visto[par]) return;

      visto[par] = 1;

      ops.push({n:par, rol:"recomendación de layering"});

    });



    previo.innerHTML =

      '<button class="cab" type="button" data-abrir="1">' +

      '<span class="ic">\ud83c\udf81</span>' +

      /* EL TITULO DICE LO QUE FALTA, no lo que ya esta. Con los dos
         elegidos seguia diciendo "Otro frasco va incluido" y parecia que
         faltaba uno. */
      '<span class="qu"><b>' + (falta <= 0
          ? (cuenta.ganados > 1 ? 'Tus ' + cuenta.ganados + ' frascos de bolsillo de 30 ml van incluidos'
                                : 'Tu frasco de bolsillo de 30 ml va incluido')
          : (falta > 1 ? 'Tus frascos de bolsillo de 30 ml van incluidos'
                       : (puestos.length ? 'Otro frasco de bolsillo de 30 ml va incluido'
                                         : 'Tu frasco de bolsillo de 30 ml va incluido'))) + '</b>' +

      /* LA CUENTA, A LA VISTA. Con dos frascos ganados no habia forma de
         saber cual llevabas ya ni cuantos faltaban. */
      '<span class="cuenta">' + vEsc(yaN.length
        ? ("Elegiste " + yaN.length + " de " + cuenta.ganados + ": " + yaN.join(", ") +
           (falta > 0 ? " \u00b7 falta " + falta : " \u00b7 toca otro para cambiarlo"))
        : (cuenta.ganados > 1 ? "Toca " + cuenta.ganados + " de la lista"
                              : "Toca cu\u00e1l lo quieres")) + '</span>' +
      '</span><span class="accion">' +

      (regaloAbierto ? "cerrar" : (yaN.length ? "cambiar" : "elegir")) + '</span></button>' +

      '<div class="ops"' + (regaloAbierto ? "" : " hidden") + ">" +
      /* 4-sep (la casa): la frase va encima de las recomendaciones de layering */
      (ops.some(function(o){ return /^combina con/.test(o.rol); }) ? '<p class="pc-frase">Aplica este perfume encima del que ya llevas y crea una fragancia única</p>' : "") +
      ops.map(function(o, k){

        var esta = !!yaPuesto[o.n];
        return '<button class="op' + (esta ? " sel" : "") + '" type="button" aria-pressed="' +
          (esta ? "true" : "false") + '" data-regalo="' + k + '">' +

          '<span>' + vEsc(o.n) + '</span><em>' + (esta ? "elegido" : vEsc(o.rol)) + '</em></button>';

      }).join("") + "</div>";

    previo.dataset.ops = JSON.stringify(ops.map(function(o){ return o.n; }));

  }



  document.addEventListener("click", function(e){
    var c = e.target.closest("[data-cambiar]");
    if(!c) return;
    e.preventDefault(); e.stopPropagation();
    /* Antes esto borraba TODOS los frascos elegidos para volver a empezar.
       Ahora solo abre la lista: los elegidos salen marcados y se cambia el
       que se quiera tocandolo. */
    regaloTocado = true;
    regaloAbierto = true;
    pintarRegalo();
  }, true);

  document.addEventListener("click", function(e){
    if(!e.target.closest("[data-abrir]")) return;

    e.preventDefault();

    e.stopPropagation();

    regaloTocado = true;

    regaloAbierto = !regaloAbierto;

    pintarRegalo();

  }, true);



  document.addEventListener("click", function(e){

    var b = e.target.closest("[data-regalo]");

    if(!b) return;

    e.preventDefault();

    e.stopPropagation();

    var caja = document.getElementById("pcRegalo");

    var ops = [];

    try{ ops = JSON.parse(caja.dataset.ops || "[]"); }catch(err){ ops = []; }

    var cual = ops[+b.dataset.regalo];

    if(!cual) return;

    /* PONER, QUITAR O CAMBIAR, todo con el mismo toque.

       Tocar el que ya llevas lo quita. Tocar otro cuando ya no caben mas
       saca el mas viejo y mete este: asi nunca se queda uno atorado
       teniendo que ir a buscar "cambiar". */
    var carro = leerCarrito();
    var mio = MARCA_REGALO + cual;
    var puestosYa = carro.filter(function(it){ return String(it.name).indexOf(MARCA_REGALO) === 0; });
    var estaba = puestosYa.some(function(it){ return it.name === mio; });

    function guardar(lista){
      try{
        localStorage.setItem("velantis-cart", JSON.stringify(lista));
        if(window.VelantisCart && window.VelantisCart.recargar) window.VelantisCart.recargar();
      }catch(err){}
    }

    if(estaba){
      guardar(carro.filter(function(it){ return it.name !== mio; }));
    }else{
      var caben = contarTallas(carro).ganados;
      if(puestosYa.length >= caben && puestosYa.length){
        var fuera = puestosYa[0].name, ido = false;
        guardar(carro.filter(function(it){
          if(!ido && it.name === fuera){ ido = true; return false; }
          return true; }));
      }
      if(window.VelantisCart && window.VelantisCart.add){

        var filaCat = (window.VELANTIS_CAT || []).filter(function(r){ return r[0] === cual; })[0];
          window.VelantisCart.add({
            name: mio, price: 0, img: filaCat && filaCat[9] ? ("n-" + filaCat[9]) : "",

          sub: "Regalo de tu promoci\u00f3n \u00b7 frasco de bolsillo 30 ml"});

      }
    }

    regaloTocado = true;
    regaloAbierto = true;

    setTimeout(pintarRegalo, 40);

  }, true);



  apagarPromos();

  apagarVideos();

  ponerBoton();

  pintarRegalo();



  document.addEventListener("click", alPagar, true);   // captura



  var t = null;

  new MutationObserver(function(){

    clearTimeout(t);

    t = setTimeout(function(){ corregirPrecios(); apagarPromos();

                                apagarVideos(); ponerBoton();

                                pintarRegalo(); pintarPaquete(); }, 60);

  }).observe(document.body, {childList:true, subtree:true});

  corregirPrecios();



  /* el aviso para quien integra: cuantas fichas ensenan un precio que la

     caja todavia no puede cobrar */

  var desfase = 0;

  Object.keys(CRUDO).forEach(function(n){

    var el = document.querySelector('[data-name="' + n.replace(/"/g,'') + '"][data-price]');

    if(el && +el.dataset.price !== PRECIO[n]) desfase++;

  });

  console.log("[compra] Shopify conectado ·",

              Object.keys(CRUDO).length, "productos cobrables");

  if(desfase) console.warn("[compra] " + desfase + " fichas ensenan el precio de "

    + "100 ml y la tienda solo tiene la variante de $389. Falta dar de alta "

    + "las presentaciones 50 ml / 100 ml en Shopify.");

})();

/* ==================================================================
   BOTON DE LA PROMOCION EN LA FICHA (3-sep-2026)
   Debajo del selector de talla. Dice cuanto falta segun el carrito, y al
   pulsarlo agrega este perfume en la talla elegida y abre el carrito, que es
   donde se escoge el frasco de regalo.
   ================================================================== */
(function(){
  var MARCA = "Bolsillo 30 ml \u00b7 ";
  function leer(){ try{ return JSON.parse(localStorage.getItem("velantis-cart")) || []; }catch(e){ return []; } }
  function esPerf(n){ if(window.VELANTIS_PAQUETE && n === window.VELANTIS_PAQUETE.obsequio) return false; return !(window.VELANTIS_CAT || []).some(function(r){ return r[0] === n && r[1] === "Ambiental"; }) && !/\u00b7 Aceite|Diffuser|Difusor/i.test(String(n||"")); }
  function contar(items){
    var n100 = 0, n50 = 0;
    items.forEach(function(it){
      if(!it || String(it.name).indexOf(MARCA) === 0 || !esPerf(it.name)) return;
      var q = Math.max(1, parseInt(it.qty, 10) || 1);
      if(String(it.talla) === "50") n50 += q; else n100 += q;
    });
    return {n100:n100, n50:n50, ganados: (window.VELANTIS_OFFERS && window.VELANTIS_OFFERS.gift30Enabled === true) ? Math.floor(n100 / 2) + Math.floor(n50 / 3) : 0};
  }
  function texto(){
    var c = contar(leer());
    var elegidos = leer().filter(function(it){ return String(it.name).indexOf(MARCA) === 0; }).length;
    if(c.ganados > elegidos)
      return "Ya tienes tu frasco de bolsillo de regalo: elígelo en el carrito";
    if(c.ganados > 0 && elegidos >= c.ganados){
      var f2 = (c.n100 % 2 === 1) ? "Elige 1 más de 100 ml" : (c.n50 % 3 === 2) ? "Elige 1 más de 50 ml" : (c.n50 % 3 === 1) ? "Elige 2 más de 50 ml" : "Elige 2 más de 100 ml o 3 de 50 ml";
      return "Tu frasco de bolsillo de regalo ya va en el carrito · " + f2 + " y llévate otro";
    }
    var f = (c.n100 % 2 === 1) ? "Elige 1 m\u00e1s de 100 ml" : (c.n50 % 3 === 2) ? "Elige 1 m\u00e1s de 50 ml" : (c.n50 % 3 === 1) ? "Elige 2 m\u00e1s de 50 ml" : "Elige 2 de 100 ml o 3 de 50 ml";
    return f + " y lleva tu esencia a todos lados con una versi\u00f3n de bolsillo (30 ml) de alguno de los que llevas";
  }
  function pintar(){
    var ml = document.getElementById("ppMl"), info = document.getElementById("ppInfo");
    if(!ml || !info || !info.dataset.name) return;
    if(!(window.VELANTIS_PROMOS && window.VELANTIS_PROMOS.bolsillo30)) return;
    var b = document.getElementById("ppBolsillo");
    if(!b){
      b = document.createElement("button");
      b.type = "button"; b.id = "ppBolsillo"; b.className = "pp-bolsillo";
      ml.insertAdjacentElement("afterend", b);
    }
    var t = texto();
    if(b.dataset.txt !== t){ b.dataset.txt = t; b.innerHTML = '<span class="ic">\ud83c\udf81</span><span>' + t.replace(/</g, "&lt;") + '</span>'; }
  }
  document.addEventListener("click", function(e){
    var b = e.target.closest("#ppBolsillo"); if(!b) return;
    e.preventDefault();
    var add = document.querySelector("#productoPage .pp-add, #ppAdd, #productoPage button.add");
    if(add) add.click();
    if(window.VelantisCart && window.VelantisCart.open) setTimeout(function(){ window.VelantisCart.open(); }, 80);
    setTimeout(pintar, 200);
  }, true);
  var t = null;
  new MutationObserver(function(){ clearTimeout(t); t = setTimeout(pintar, 80); }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:["data-name","class"]});
  window.addEventListener("storage", pintar);
  window.addEventListener("hashchange", function(){ setTimeout(pintar, 150); });
  pintar();
})();

/* ==================================================================
   BOTON FLOTANTE DEL CARRITO (5-sep-2026, pedido de la casa)
   El carrito «se perdia»: solo se abria desde el icono de la cabecera.
   Este boton vive abajo a la derecha en todas las vistas, muestra la
   cantidad de piezas (la misma que el punto de la cabecera) y al tocarlo
   abre el carrito. Se esconde mientras el carrito esta abierto.
   Se sincroniza por reloj (400 ms) y solo escribe cuando algo cambio:
   un observador sobre el body se disparaba a si mismo y congelaba la pagina.
   ================================================================== */
(function(){
  if(document.getElementById("vFlotCarrito")) return;
  var b = document.createElement("button");
  b.id = "vFlotCarrito"; b.type = "button"; b.setAttribute("aria-label", "Abrir carrito");
  b.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 8h12l-1 12H7L6 8z"></path><path d="M9 8V6a3 3 0 0 1 6 0v2"></path></svg><span class="n">0</span>';
  document.body.appendChild(b);
  var num = b.querySelector(".n"), ultimo = null;
  b.addEventListener("click", function(){
    if(window.VelantisCart && VelantisCart.open){ VelantisCart.open(); return; }
    var h = document.querySelector('.icon-btn[aria-label="Carrito"]'); if(h) h.click();
  });
  function sync(){
    var d = document.querySelector(".cart-dot"), n = d ? (parseInt(d.textContent, 10) || 0) : 0;
    var ov = document.getElementById("cartOv"), abierto = !!(ov && ov.classList.contains("show"));
    var estado = n + "|" + abierto;
    if(estado === ultimo) return;
    ultimo = estado;
    num.textContent = String(n);
    b.classList.toggle("vacio", n === 0);
    b.classList.toggle("oculto", abierto);
  }
  sync();
  setInterval(sync, 400);
})();
;
/* index-45 */


(function(){

  "use strict";

  /* Los datos de la segunda presentacion, leidos del mismo JSON que cobra

     el carrito. Sin datos, vPres.tiene() es false y no aparece ninguna

     pastilla: el sitio se comporta como antes. */

  var CX = {};

  try{ CX = JSON.parse(document.getElementById("pc-conexion").textContent) || {}; }catch(e){}

  function norm(s){

    return String(s||"").normalize("NFD").replace(/[̀-ͯ]/g,"")

      .toLowerCase().replace(/[^a-z0-9]+/g," ").trim();

  }

  function indexar(o){ var r = {}; Object.keys(o||{}).forEach(function(k){ r[norm(k)] = o[k]; }); return r; }

  var V50 = indexar(CX.variantes50), P50 = indexar(CX.precios50), P100 = indexar(CX.precios);
  /* El nombre EXACTO manda. «SANTAL 33» (perfume, $589) y «Santal 33»
     (ambiental, $449) caen en la misma casilla normalizada y ganaba el
     ultimo: la pastilla de 100 ml del perfume decia $449. El normalizado
     queda solo como atajo cuando el exacto no existe. */
  var V50X = CX.variantes50 || {}, P50X = CX.precios50 || {}, P100X = CX.precios || {};
  function busca(X, N, n){ var t = String(n||"").trim(); if(X[t] != null) return X[t]; /* 15-sep: el nombre exacto existe (p. ej. el aromatizante «Santal 33») y no trae este dato: no se toma el del perfume */ if(X !== P100X && P100X[t] != null) return undefined; return N[norm(t)]; }
  window.vPres = {
    tiene:  function(n){ return busca(V50X, V50, n) != null; },
    id50:   function(n){ return busca(V50X, V50, n) || null; },
    precio: function(n, tl){ var p = (tl === "50") ? busca(P50X, P50, n) : busca(P100X, P100, n); return (p == null) ? null : +p; }
  };



  /* La ficha: donde decia «100 ml» ahora se elige. */

  function pintarFicha(){

    var info = document.getElementById("ppInfo"), ml = document.getElementById("ppMl");

    if(!info || !ml) return;

    var nombre = info.dataset.name || "";

    if(ml.dataset.para === nombre) return;          /* ya esta pintada para este producto */

    ml.dataset.para = nombre;

    info.dataset.talla = "100";
    /* 3-sep (mapa vivo): el precio grande de la ficha sale del MAPA, no del
       texto del catalogo. Antes lo ponia un guion que sustituia «$590» por
       el precio mas comun: si un perfume cambiaba de precio en Shopify, la
       pastilla lo decia y el precio grande no. */
    (function(){ var p100 = window.vPres.precio(nombre, "100"); if(p100 == null) return;
      info.dataset.price = p100;
      var vis = document.querySelector("#productoPage .pp-price");
      if(vis) vis.textContent = "$" + p100.toLocaleString("es-MX") + " MXN"; })();

    if(!window.vPres.tiene(nombre)){ ml.textContent = "100 ml"; ml.classList.remove("pp-talla"); return; }

    ml.classList.add("pp-talla");

    ml.innerHTML = /* 3-sep: la casa quiere el 50 ml a la izquierda; el 100 ml sigue elegido de inicio */
  ["50","100"].map(function(tl){

      var p = window.vPres.precio(nombre, tl);

      return '<button type="button" data-tl="' + tl + '"' + (tl === "100" ? ' class="on"' : '') + '>'

           + tl + ' ml' + (p != null ? ' · $' + p.toLocaleString("es-MX") : '') + '</button>';

    }).join("");

  }

  document.addEventListener("click", function(e){

    var b = e.target.closest("#ppMl button[data-tl]"); if(!b) return;

    var info = document.getElementById("ppInfo"); if(!info) return;

    var tl = b.dataset.tl, p = window.vPres.precio(info.dataset.name, tl);

    info.dataset.talla = tl;

    if(p != null){

      info.dataset.price = p;

      var vis = document.querySelector("#productoPage .pp-price");

      if(vis) vis.textContent = "$" + p.toLocaleString("es-MX") + " MXN";

    }

    Array.prototype.forEach.call(b.parentNode.children, function(x){ x.classList.toggle("on", x === b); });

  });

  var t;

  new MutationObserver(function(){ clearTimeout(t); t = setTimeout(pintarFicha, 60); })

    .observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:["data-name","style","class"]});

  window.addEventListener("hashchange", function(){ setTimeout(pintarFicha, 120); });

  pintarFicha();

})();

;
/* index-46 */

(function(){
  "use strict";
  /* --- entrada: numerar los bloques visibles de arriba hacia abajo --- */
  function numerar(){
    var i = 0;
    Array.prototype.forEach.call(document.body.children, function(el){
      if(!el.matches || !el.matches(".topbar, header, section, footer, .divider, .wrap")) return;
      var cs = getComputedStyle(el);
      if(cs.display === "none" || cs.position === "fixed") return;
      el.style.setProperty("--vi", String(Math.min(i, 6)));
      el.classList.add("v-in");
      i++;
    });
  }
  /* --- videos: el fotograma llego, que se vea --- */
  document.addEventListener("loadeddata", function(e){
    var v = e.target;
    if(v && v.tagName === "VIDEO") v.classList.add("listo");
  }, true);
  /* --- catalogo: tarjetas que no tienen escena se muestran de inmediato --- */
  /* Los TRES mapas del motor. Un ambiental no esta en el mapa de perfumes:
     preguntarle al equivocado marcaria «sin escena» a los 38 ambientales. */
  function leer(id){
    try{ return JSON.parse(document.getElementById(id).textContent); }catch(e){ return null; }
  }
  var MAPA = leer("pm-mapa"), MAPA_ACE = leer("pm-mapaace"), MAPA_AMB = leer("pm-mapaamb");
  function norm(s){
    return String(s||"").normalize("NFD").replace(/[̀-ͯ]/g,"")
      .toLowerCase().replace(/[^a-z0-9]+/g," ").trim();
  }
  /* El mismo orden que usa el motor: lo especifico antes que lo general.
     Las tarjetas de ambiental tambien llevan `oil-img`, asi que preguntar por
     aceite primero las mandaria al mapa equivocado. */
  function mapaDe(el){
    var t = el.closest("[data-img]"), marca = t ? (t.getAttribute("data-img") || "") : "";
    if(el.classList.contains("amb-card-img") || el.classList.contains("amb-img")
       || marca === "amb-img" || /^n-amb/.test(marca)) return MAPA_AMB || MAPA;
    if(el.classList.contains("oil-img")) return MAPA_ACE || MAPA;
    return MAPA;
  }
  function nombreDe(el){
    var lhs = el.closest("[data-lhs]");
    if(lhs && lhs.getAttribute("data-lhs")) return lhs.getAttribute("data-lhs").replace(/^AMB:/, "");
    var host = el.closest("[data-name]");
    return host ? (host.getAttribute("data-name") || "") : "";
  }
  var SEL = ".cat-grid .cat-img, .oil-grid .oil-img, .oil-grid .amb-img,"
          + " .oil-grid .amb-card-img, .cc-page .cat-img, .cc-page .oil-img";
  function clasificar(){
    if(!MAPA && !MAPA_AMB && !MAPA_ACE) return;
    var v = document.querySelectorAll(SEL);
    for(var i = 0; i < v.length; i++){
      var el = v[i];
      if(el.classList.contains("con-motor") || el.classList.contains("sin-motor")) continue;
      var m = mapaDe(el), nom = norm(nombreDe(el));
      /* Sin formula en SU mapa, la foto de familia es su cara definitiva:
         se ensena ya en vez de dejar el hueco esperando una escena que no
         va a llegar. Son las fragancias que todavia no tienen notas. */
      if(!m || !nom || m[nom] == null) el.classList.add("sin-motor");
    }
  }
  /* El respaldo NO es por reloj, es por cercania.

     El motor monta la escena cuando la tarjeta esta a 1500 px de la pantalla.
     Un respaldo a los 2.4 s desde que carga la pagina destapaba con su foto
     de familia tarjetas que el motor todavia no habia mirado: al bajar, la
     foto cambiaba a escena delante de la persona. Eso es lo que se veia en
     ambientales, donde 23 de 38 tardan en llegar.

     Ahora cada tarjeta recibe su propio plazo, y solo cuando se acerca: si
     en 1.2 s el motor no le puso escena, se ensena con su foto —que para las
     fragancias sin notas es su cara definitiva—. Las lejanas ni se miran. */

  /* EL ACEITE DEL DIFUSOR (reportado por Mayto, 1-sep: «en los difusores no
     dice que incluye 100 ml de aceite hasta que le das click a la imagen»).

     El dato ya existia: cada difusor trae «Aroma incluido» en su lista de
     caracteristicas, y al abrirlo aparece el selector del aceite de 100 ml.
     Pero la tarjeta del listado solo ensenaba la descripcion, asi que quien
     comparaba precios no sabia que el aceite venia dentro.

     No es una promocion —no depende de ningun descuento de Shopify—: es lo
     que el producto incluye, dicho por la casa. Por eso se anuncia sin
     condicion. Se escribe en el DOM en vez de en el dato para no tocar el
     catalogo del sitio: si manana cambia, se quita esta linea. */
  function vDifusor(){
    var v = document.querySelectorAll("#difusoresPage [data-name]");
    for(var i = 0; i < v.length; i++){
      var c = v[i];
      if(c.dataset.vDif) continue;
      if(!/difusor/i.test(c.dataset.sub || "")) continue;
      var donde = c.querySelector(".oil-desc, .dif-desc, p");
      if(!donde) continue;
      c.dataset.vDif = "1";
      var n = document.createElement("div");
      n.className = "v-incluye";
      n.textContent = "Incluye aceite de 100 ml";
      donde.parentNode.insertBefore(n, donde.nextSibling);
    }
  }


  /* «CUANDO LES DAS CLICK NO HAY NADA EN LA PARTE DE ABAJO COMO EN LOS
     PERFUMES» (retro del 1-sep).

     Medido: la ficha de un perfume mide 3401 px y trae cuatro bloques
     —volver, producto, resenas y «tambien te puede gustar»—. La de un
     ambiental mide 737 y trae dos: se acaba de golpe y se siente rota.

     Aqui se le anade el bloque que de verdad sirve: otros productos de SU
     misma categoria. No se inventa marcado: se clonan las tarjetas que ya
     existen en la pagina de la categoria, con su mismo aspecto y su mismo
     boton de comprar.

     Detalle que importa: al clonar un <canvas> se copia el elemento pero NO
     lo que hay dibujado dentro. Por eso se le quitan los lienzos y las
     marcas del motor (`con-motor`, `data-pmHecho`): asi el motor las trata
     como tarjetas nuevas y les dibuja su escena. Si se clonaran tal cual,
     saldrian ocho recuadros vacios.

     Las resenas NO se traen. Son un carrusel de video con estado propio
     —indice, observadores, precarga—; duplicarlo o moverlo rompe el de la
     portada, y una seccion rota es peor que una seccion ausente. */
  /* Marcado de las tarjetas de cada categoria, tal como se vio la ultima
     vez que se visito. Se llena solo. */
  var GUARDADAS = {};
  function vGuardar(){
    for(var ruta in RUTA_A_PAGINA){
      var p = document.getElementById(RUTA_A_PAGINA[ruta]);
      if(!p || getComputedStyle(p).display === "none") continue;
      var v = p.querySelectorAll("[data-name]");
      if(v.length < 2) continue;
      var lista = [];
      for(var i = 0; i < v.length && lista.length < 12; i++){
        lista.push({
          nombre: (v[i].getAttribute("data-name") || "").toLowerCase().trim(),
          html: v[i].outerHTML
        });
      }
      GUARDADAS[ruta] = lista;
    }
  }
  var RUTA_A_PAGINA = {
    "#/ambientales": "ambientalesPage",
    "#/aceites":     "aceitesPage",
    "#/difusores":   "difusoresPage"
  };
  function vSimilares(){
    var pag = document.getElementById("lhsPage");
    if(!pag || getComputedStyle(pag).display === "none") return;
    var wrap = pag.querySelector(".wrap");
    var atras = document.getElementById("lhsBack");
    if(!wrap || !atras) return;

    var ruta = (atras.getAttribute("href") || "").split("?")[0];
    var idOrigen = RUTA_A_PAGINA[ruta];
    var origen = idOrigen ? document.getElementById(idOrigen) : null;
    if(!origen) return;

    /* Quien se esta viendo, para no ofrecerselo a si mismo. */
    var actual = ((location.hash || "").split("/lhs/")[1] || "");
    try{ actual = decodeURIComponent(actual); }catch(e){}
    actual = actual.replace(/^AMB:/, "").toLowerCase().trim();

    /* Se rehace solo si cambio el producto. */
    var ya = wrap.querySelector(".v-sim");
    if(ya && ya.dataset.para === actual) return;
    if(ya) ya.parentNode.removeChild(ya);

    /* La rejilla de la categoria se dibuja SOLO mientras esa ruta esta
       activa: con la ficha abierta esta vacia, asi que no hay de donde
       clonar. Por eso se guarda su marcado al pasar por ella —que es el
       camino normal, se llega a la ficha pulsando una tarjeta— y aqui se
       reconstruye desde ese guardado. Si alguien entra directo por enlace
       sin haber visto la categoria, la seccion no aparece: eso deja la
       ficha como esta hoy, nunca peor. */
    var guardadas = GUARDADAS[ruta] || [];
    var elegidas = [];
    for(var i = 0; i < guardadas.length && elegidas.length < 4; i++){
      if(guardadas[i].nombre !== actual) elegidas.push(guardadas[i].html);
    }
    if(!elegidas.length) return;

    var sec = document.createElement("div");
    sec.className = "pp-section v-sim";
    sec.dataset.para = actual;
    var cab = document.createElement("div");
    cab.className = "sec-head";
    cab.innerHTML = '<span class="eyebrow">También te puede gustar</span>'
                  + '<h2>De la misma colección</h2>';
    var rej = document.createElement("div");
    rej.className = "oil-grid v-sim-grid";

    elegidas.forEach(function(html){
      var caja = document.createElement("div");
      caja.innerHTML = html;
      var copia = caja.firstElementChild;
      if(!copia) return;
      /* fuera los lienzos vacios y las marcas del motor: que los dibuje */
      [].slice.call(copia.querySelectorAll("canvas")).forEach(function(k){
        k.parentNode.removeChild(k);
      });
      [].slice.call(copia.querySelectorAll("[data-pm-hecho], [data-pm-id]"))
        .concat([copia]).forEach(function(k){
          if(!k.removeAttribute) return;
          k.removeAttribute("data-pm-hecho");
          k.removeAttribute("data-pm-id");
          k.removeAttribute("data-v-obs");
          if(k.classList){ k.classList.remove("con-motor"); k.classList.remove("sin-motor"); }
        });
      [].slice.call(copia.querySelectorAll(".con-motor, .sin-motor")).forEach(function(k){
        k.classList.remove("con-motor"); k.classList.remove("sin-motor");
        k.removeAttribute("data-pm-hecho"); k.removeAttribute("data-pm-id");
        k.removeAttribute("data-v-obs");
      });
      rej.appendChild(copia);
    });

    sec.appendChild(cab);
    sec.appendChild(rej);
    wrap.appendChild(sec);
  }


  /* La TARJETA entera entra en fundido, no solo su imagen. Se marca cuando
     su hueco ya esta resuelto —el motor le puso escena, o se sabe que no
     tiene—, asi el fundido acompana a la imagen en vez de adelantarsele. */
  function vMarcarTarjetas(){
    var v = document.querySelectorAll(SEL);
    for(var i = 0; i < v.length; i++){
      var el = v[i];
      if(!el.classList.contains("con-motor") && !el.classList.contains("sin-motor")) continue;
      var t = el.closest(".cat-grid > *, .oil-grid > *");
      if(t && !t.classList.contains("v-listo")) t.classList.add("v-listo");
    }
    /* Las que no llevan hueco de motor (por si alguna rejilla cambia) no se
       quedan escondidas: a los 2 s se muestran igual. */
    var todas = document.querySelectorAll(".cat-grid > *:not(.v-listo), .oil-grid > *:not(.v-listo)");
    for(var j = 0; j < todas.length; j++){
      var c = todas[j];
      if(c.dataset.vPlazo) continue;
      c.dataset.vPlazo = "1";
      (function(x){ setTimeout(function(){ x.classList.add("v-listo"); }, 150); })(c); /* 4-sep: antes 2000 ms; la rejilla se veia en blanco 2-5 s tras cada filtro */
    }
  }




  /* Las politicas de la tienda existen y estan bien escritas; lo que faltaba
     era enlazarlas. Se anaden al pie, junto al domicilio. Si Shopify no las
     tuviera, los enlaces no se pintan. */
  function vLegales(){
    var pie = document.querySelector("footer .foot-bottom, footer .foot-legal, footer");
    if(!pie || pie.dataset.rlFooter === "minimal" || document.getElementById("vera-pie")) return;
    var caja = document.createElement("div");
    caja.id = "vera-pie";
    caja.className = "v-legales";
    caja.innerHTML = [
      ['/policies/privacy-policy',  'Aviso de privacidad'],
      ['/policies/refund-policy',   'Devoluciones'],
      ['/policies/shipping-policy', 'Envíos'],
      ['/policies/terms-of-service','Términos y condiciones'],
      ['/policies/legal-notice',    'Aviso legal']
    ].map(function(p){
      return '<a href="' + p[0] + '">' + p[1] + '</a>';
    }).join('<span aria-hidden="true"> · </span>');
    pie.appendChild(caja);
  }

  var CERCA = null;
  function vigilar(){
    if(!("IntersectionObserver" in window)) return null;
    return new IntersectionObserver(function(es){
      es.forEach(function(en){
        if(!en.isIntersecting) return;
        var el = en.target;
        CERCA.unobserve(el);
        setTimeout(function(){
          if(!el.classList.contains("con-motor")) el.classList.add("sin-motor");
          vMarcarTarjetas();
        }, 1200);
      });
    }, {rootMargin: "1600px"});
  }
  function observarNuevas(){
    if(!CERCA) return;
    var v = document.querySelectorAll(SEL);
    for(var i = 0; i < v.length; i++){
      var el = v[i];
      if(el.dataset.vObs) continue;
      el.dataset.vObs = "1";
      CERCA.observe(el);
    }
  }
  var t;
  function arrancar(){
    numerar(); clasificar(); vDifusor(); vMarcarTarjetas(); vLegales();
    window.addEventListener("hashchange", function(){ setTimeout(function(){ vGuardar(); vSimilares(); }, 200); });
    CERCA = vigilar();
    if(!CERCA) document.body.classList.add("no-js-revela");
    observarNuevas();
    new MutationObserver(function(){
      clearTimeout(t);
      t = setTimeout(function(){ clasificar(); observarNuevas(); vDifusor(); vGuardar(); vSimilares(); vMarcarTarjetas(); }, 60);
    }).observe(document.body, {childList:true, subtree:true});
    /* 4-sep: red de seguridad. Si una rejilla se redibuja y la senal del motor no llega
       (Ambientales al volver de una ficha), las tarjetas quedaban transparentes para siempre. */
    setInterval(vMarcarTarjetas, 2500);   /* 7-sep: cada 2.5 s basta; a 1 s pesaba en reposo */
  }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", arrancar);
  else arrancar();
})();

/* Lo que Shopify no puede cobrar se aparta por WhatsApp.
   ------------------------------------------------------------------------
   153 perfumes, 7 difusores, 38 aceites y 17 ambientales del catálogo no
   existen como producto en la tienda. Antes se podían agregar al carrito y el
   fallo aparecía hasta el final, al pagar.

   No se esconden —Velantis quiere ver su catálogo completo, y el cliente
   quiere encontrar su perfume—: cambia el botón. Es la misma salida que
   describe el LEEME del sitio: lo que no se cobra en línea se aparta por
   WhatsApp.

   El día que la casa los dé de alta en Shopify, `sin_variante` deja de
   listarlos y los botones vuelven solos. */
(function(){
  "use strict";
  var CX = {};
  try{ CX = JSON.parse(document.getElementById("pc-conexion").textContent); }
  catch(e){ return; }

  var SIN = {};
  (CX.sin_variante || []).forEach(function(p){
    if(p && p.nombre) SIN[norm(p.nombre)] = true;
  });
  var HAY = {};
  Object.keys(CX.variantes || {}).forEach(function(n){ HAY[norm(n)] = true; });

  function norm(s){
    return String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
      .toUpperCase().replace(/[^A-Z0-9]/g, "");
  }

  function cobrable(nombre){
    var n = norm(nombre);
    if(HAY[n]) return true;
    if(SIN[n]) return false;
    return null;                      // no se sabe: no se toca el botón
  }

  function marcar(){
    var botones = document.querySelectorAll(
      ".add:not([data-arreglado]), .pp-add:not([data-arreglado])");
    [].forEach.call(botones, function(b){
      var caja = b.closest("[data-name]") || b.closest(".card") || b.parentElement;
      var nombre = (caja && (caja.dataset.name || (caja.querySelector("h3,h4,.card-name")||{}).textContent)) || "";
      if(!nombre.trim()) return;
      b.setAttribute("data-arreglado", "1");
      if(cobrable(nombre) !== false) return;

      b.classList.add("no-cobrable");
      b.textContent = "Apartar por WhatsApp";
      b.addEventListener("click", function(e){
        e.preventDefault(); e.stopImmediatePropagation();
        window.open((CX.wa || "") + "?text=" + encodeURIComponent(
          "Hola Velantis, quiero apartar " + nombre.trim() + "."), "_blank");
      }, true);
    });
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", marcar);
  }else{ marcar(); }
  new MutationObserver(marcar).observe(document.body,
    {childList:true, subtree:true});
})();
;
/* index-47 */

/* ── rutas sin producto ────────────────────────────────────────────────────
   Medido en navegador: #/best-sellers, #/novedades y #/prive muestran CERO
   fragancias, mientras Dama y Caballero traen 24. Son secciones armadas para
   un catalogo que todavia no se lleno.

   No se borran del codigo —la casa las va a querer— pero se retiran de la
   navegacion mientras esten vacias. Mandar a alguien a una pagina sin nada es
   otra forma de mentirle, y ademas ahi apuntaba el banner del carrito.

   Se comprueba en vivo, no por lista: el dia que tengan producto, el enlace
   reaparece solo. */
(function(){
  "use strict";
  var CANDIDATAS = ["best-sellers", "novedades", "prive"];

  function revisar(){
    CANDIDATAS.forEach(function(r){
      var seccion = document.querySelector('[data-ruta="' + r + '"]')
                 || document.getElementById("r-" + r)
                 || document.getElementById(r + "Page");
      /* Sin seccion en el documento la ruta no pinta NADA: el enlace lleva a
         una pantalla en blanco. Comprobado en navegador para las tres.
         Con seccion, se mira si trae producto. En los dos casos la respuesta
         se recalcula sola, asi que el dia que exista y se llene, el enlace
         reaparece sin tocar esto. */
      var tiene = !!seccion &&
                  seccion.querySelectorAll(".card,.tarjeta,[data-name]").length > 0;
      [].forEach.call(document.querySelectorAll('a[href="#/' + r + '"]'),
        function(a){ a.hidden = !tiene; });
    });
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", revisar);
  }else{ revisar(); }
  window.addEventListener("hashchange", revisar);
  setTimeout(revisar, 4000);   // el catalogo se llena despues de cargar
})();
;
/* index-48 */

/* ── el formulario de correo, honesto ──────────────────────────────────────
   Promete un cupon de bienvenida y no guarda el correo en ningun lado. Hasta
   que se conecte a Shopify o a un gestor de listas, el boton hace lo unico
   que si funciona hoy: abrir WhatsApp, que es donde la casa atiende. */
(function(){
  "use strict";
  document.addEventListener("submit", function(e){
    var f = e.target.closest("[data-a-whatsapp]");
    if(!f) return;
    e.preventDefault();
    var campo = f.querySelector("input[type=email], input[type=text]");
    var correo = campo ? campo.value.trim() : "";
    window.open("https://wa.me/5216629375124?text=" + encodeURIComponent(
      "Hola Velantis, quiero recibir novedades y mi cupón de bienvenida."
      + (correo ? " Mi correo es " + correo + "." : "")), "_blank");
    if(campo) campo.value = "";
  }, true);
})();
;
/* index-49 */

(function(){
  "use strict";
  var n = document.getElementById("pc-conexion");
  if(!n) return;
  var CX; try{ CX = JSON.parse(n.textContent); }catch(e){ return; }

  var precios = CX.precios || {}, vars_ = CX.variantes || {};
  var vivos = Object.keys(vars_).filter(function(k){ return precios[k] > 0; });
  if(!vivos.length) return;

  /* El precio unico es el que mas se repite, no el promedio: 414 perfumes
     comparten uno y 29 ambientales valen menos. La moda describe el catalogo;
     el promedio no describiria a nadie. */
  var veces = {}, moda = 0, tope = 0;
  vivos.forEach(function(k){
    var p = precios[k];
    veces[p] = (veces[p] || 0) + 1;
    if(veces[p] > tope){ tope = veces[p]; moda = p; }
  });

  var mx = function(v){ return "$" + Math.round(v).toLocaleString("es-MX"); };
  var precioUnico = mx(moda);
  var nUnico      = tope;
  var nTotal      = vivos.length;
  var redondo     = Math.floor(nTotal / 100) * 100;

  function pasada(raiz){
    var w = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, {
      acceptNode: function(t){
        if(t.parentElement && t.parentElement.closest(".rl-diff-aromas")) return NodeFilter.FILTER_REJECT;
        var et = t.parentNode && t.parentNode.nodeName;
        if(et === "SCRIPT" || et === "STYLE" || et === "TEXTAREA")
          return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodos = [], tocados = 0;
    while(w.nextNode()) nodos.push(w.currentNode);
    nodos.forEach(function(t){
      var v = t.nodeValue, o = v;
      /* 4-sep (mapa vivo): «$590» solo se corrige dentro de la frase del catalogo
         («N perfumes disponibles · precio $590»). El reemplazo global de antes
         pisaba precios reales (SANTAL 33 a $590 se veia $589 en ficha y carrito). */
      if(/fragancias\s+disponibles|perfumes\s+disponibles/i.test(v)) v = v.replace(/\$\s?590(?!\d)/g, precioUnico);
      v = v.replace(/\b\d{3}\s+fragancias\s+disponibles/gi,
                    nUnico + " perfumes disponibles");
      if(/^\s*\+\s?\d{3}\s*$/.test(v) && redondo) v = "+" + redondo;
      if(v !== o){ t.nodeValue = v; tocados++; }
    });
    return tocados;
  }

  var primera = pasada(document.body);

  /* El carrito se dibuja DESPUES, cada vez que alguien agrega algo, y sus
     renglones nacen con el precio del catalogo. Una sola pasada al cargar los
     dejaba diciendo $590 mientras la caja cobraba otra cosa: exactamente lo
     que se pidio evitar. Asi que se vuelve a pasar sobre lo que aparezca.

     Se desconecta durante la pasada porque cambiar el texto dispara al
     observador y se llamaria a si mismo sin fin. Converge sola: despues de la
     primera vez ya no queda nada que cambiar. */
  var obs, pendiente = 0;
  function revisar(){
    if(pendiente) return;
    pendiente = setTimeout(function(){
      pendiente = 0;
      obs.disconnect();
      try{ pasada(document.body); }
      finally{ obs.observe(document.body, {childList:true, subtree:true,
                                           characterData:true}); }
    }, 60);
  }
  obs = new MutationObserver(revisar);
  obs.observe(document.body, {childList:true, subtree:true, characterData:true});

  if(window.console && console.info)
    console.info("[velantis] cifras al dia: " + precioUnico + " x" + nUnico +
                 " perfumes, " + nTotal + " cobrables (" + primera +
                 " textos, vigilando el carrito)");
})();
;
/* index-50 */

(function(){
  "use strict";
  var CX = {};
  try{ CX = JSON.parse(document.getElementById("pc-conexion").textContent); }
  catch(e){ return; }

  function norm(s){
    return String(s || "").normalize("NFD").replace(/[̀-ͯ]/g, "")
      .toUpperCase().replace(/[^A-Z0-9]/g, "");
  }
  /* Dos indices: por nombre EXACTO y por forma normalizada. El exacto manda.
     Hay siete pares perfume/ambiental con el mismo nombre —«BERGAMOTE 22» de
     $589 y «Bergamote 22» de $449— y normalizando se confunden: el ambiental
     heredaba el «si» del perfume y se quedaba a la vista sin poderse cobrar.
     Mismo criterio que el arreglo 30 para el precio. */
  var HAY_X = {}, SIN_X = {}, HAY = {}, SIN = {};
  Object.keys(CX.variantes || {}).forEach(function(n){ HAY_X[n] = true; HAY[norm(n)] = true; });
  (CX.sin_variante || []).forEach(function(p){
    if(p && p.nombre){ SIN_X[p.nombre] = true; SIN[norm(p.nombre)] = true; }
  });
  /* Los ambientales se registran con prefijo AMB: para no chocar con el
     perfume del mismo nombre. Se quita para consultar el mapa. */
  function limpio(nombre){ return String(nombre || "").replace(/^AMB:/, ""); }
  function enLista(clave, nombre){
    var L = (CX && CX[clave]) || []; var n = limpio(nombre).trim();
    for(var i=0;i<L.length;i++){ if(String(L[i]).trim() === n) return true; }
    return false;
  }
  function cobrable(nombre){
    var x = limpio(nombre);
    if(HAY_X[x]) return true;          /* nombre exacto: se cobra */
    if(SIN_X[x]) return false;         /* nombre exacto: no se cobra */
    var n = norm(x);
    if(HAY[n] && !SIN[n]) return true; /* parecido sin ambiguedad */
    if(SIN[n] && !HAY[n]) return false;
    return null;                       /* ambiguo o ajeno (difusor, aroma): no se toca */
  }

  var ocultas = 0;

  function esconderTarjetas(){
    var cajas = document.querySelectorAll(
      ".card[data-name]:not(.al-oculto), .cat-card[data-name]:not(.al-oculto), " +
      "article[data-name]:not(.al-oculto), li[data-name]:not(.al-oculto), " +
      ".oil-card:not(.al-oculto), .dif-card:not(.al-oculto), [data-lhs]:not(.al-oculto)");
    [].forEach.call(cajas, function(c){
      if(c.id === "ppInfo") return;
      /* Regla estricta (2-sep, segunda vuelta): solo se queda lo que SE COBRA.
         Un aroma o un difusor sin codigo no es «no se sabe»: es «no se paga»,
         y su boton acaba en WhatsApp. Se esconde igual. */
      /* Tres marcados distintos, tres reglas:
           · perfume del catalogo: data-name, sin data-lhs -> cobrable(nombre)
           · ambiental: data-lhs="AMB:nombre"             -> cobrable(nombre)
           · aroma, aceite, difusor: data-lhs sin prefijo -> NUNCA se cobra.
         El tercero importa: trece aromas se llaman igual que un ambiental
         cobrable («Santal 33», «Aventus»...) y por nombre se colaban. */
      var lhs = c.dataset.lhs;
      var seVende;
      if(lhs != null && lhs !== ""){
        /* 3-sep: aceites y difusor ya existen en Shopify; se deciden por el mapa como todo lo demas */
          /* aceite: su tarjeta vale si SU aceite existe (no el ambiental homonimo);
             difusor: si esta en la lista; ambiental y lo demas: por el mapa */
          /* el ambiental lleva prefijo AMB: y se decide por el mapa ANTES de
             mirar la clase: su tarjeta es del mismo tipo que la del aceite y
             la lista de aceites lo escondia si no era tambien aroma de difusor */
          seVende = /^AMB:/.test(lhs) ? (cobrable(lhs) === true)
                  : c.classList.contains("oil-card") ? enLista("aceites", lhs)
                  : (c.classList.contains("dif-card") || c.classList.contains("gs-item")) && enLista("difusores", lhs) ? true
                  : (cobrable(lhs) === true);
      }else{
        seVende = cobrable(c.dataset.name || "") === true;
      }
      if(!seVende){
        c.classList.add("al-oculto");
        c.setAttribute("aria-hidden", "true");
        ocultas++;
      }
    });
  }

  /* Un carrusel o rejilla sin nada visible se esconde con su encabezado. */
  function esconderVacios(){
    /* Difusores y aceites: si no queda nada que vender, la pagina ensena su
       aviso de «Catalogo en preparacion» (ya existe en el HTML) y el enlace
       del menu se retira, como hace el arreglo de rutas con las secciones
       vacias. Mandar a alguien a una pagina sin nada es otra forma de mentir. */
    [["difusores", "#difusoresCatalog, #difusoresGrid", "#difusoresSoon"],
     ["aceites",   "#aceitesCatalog, #aceitesGrid",     "#aceitesSoon"],
     ["ambientales", "#ambCatalog", null]].forEach(function(r){
      var sel = r[1].split(",").map(function(c){ c = c.trim(); return c + " [data-name], " + c + " [data-lhs]"; }).join(", ");
      var cajas = document.querySelectorAll(sel);
      if(!cajas.length) return;
      var visibles = 0;
      [].forEach.call(cajas, function(t){ if(!t.classList.contains("al-oculto")) visibles++; });
      var enlaces = document.querySelectorAll('a[href="#/' + r[0] + '"]');
      [].forEach.call(enlaces, function(a){ a.classList.toggle("al-oculto", visibles === 0); });
      if(r[2]){
        var aviso = document.querySelector(r[2]);
        if(aviso) aviso.style.display = visibles === 0 ? "" : "none";
      }
    });
    var pistas = document.querySelectorAll(".car-track, .cat-grid, .oil-catalog, .dif-catalog, .dif-grid");
    [].forEach.call(pistas, function(p){
      var tarjetas = p.querySelectorAll("[data-name], [data-lhs]");
      if(!tarjetas.length) return;
      var visibles = 0;
      [].forEach.call(tarjetas, function(t){ if(!t.classList.contains("al-oculto")) visibles++; });
      var bloque = p.closest(".car") || p.closest("section") || p;
      if(visibles === 0){ bloque.classList.add("al-oculto"); }
      else{ bloque.classList.remove("al-oculto"); }
    });
  }

  /* Enlace directo a la ficha de un producto oculto: de vuelta al catalogo.
     Se decide con el data-name de la ficha, que la ruta ya rellena. */
  function vigilarFicha(){
    var info = document.getElementById("ppInfo");
    if(info && info.dataset.name && cobrable(info.dataset.name) === false){
      if(window.console && console.info)
        console.info("[velantis] ficha de un producto no cobrable: " + info.dataset.name + " -> catalogo");
      location.hash = "#/";
      return;
    }
    var lhs = document.getElementById("lhsPage");
    if(lhs && !lhs.hidden && /^#\/lhs\//.test(location.hash)){
      var nombre = decodeURIComponent(location.hash.replace(/^#\/lhs\//, ""));
      var reg = (window.VELANTIS_LHS||{})[nombre.replace(/^AMB:/,"")] || {};
        var vendible = /^AMB:/.test(nombre) ? (cobrable(nombre) === true)
                     : (reg.kind === "difusor") ? enLista("difusores", nombre)
                     : (reg.kind === "aceite" || reg.kind === "aroma") ? enLista("aceites", nombre)
                     : (cobrable(nombre) === true);
      if(!vendible) location.hash = "#/";
    }
  }

  var pendiente = null;
  function pasar(){
    if(pendiente) return;
    pendiente = setTimeout(function(){
      pendiente = null;
      esconderTarjetas();
      esconderVacios();
      vigilarFicha();
    }, 30);
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", pasar);
  }else{ pasar(); }
  window.addEventListener("hashchange", pasar);
  new MutationObserver(pasar).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:["data-name"]});

  /* para las pruebas: cuantas se escondieron */
  window.VELANTIS_OCULTAS = function(){ return document.querySelectorAll(".al-oculto[data-name], .al-oculto[data-lhs]").length; };
})();

/* ==================================================================
   TARJETAS CON LOS DOS PRECIOS (3-sep-2026)

   La casa vende dos tamanos y la tarjeta ensenaba uno. Aqui se leen
   los dos del mismo mapa que cobra el carrito (precios / precios50),
   por nombre EXACTO primero y normalizado como atajo, y se pintan
   «100 ml $589 · 50 ml $389». Si la fragancia no tiene 50 ml, la
   tarjeta se queda como estaba. El boton sigue agregando el de 100 ml:
   la talla se elige en la ficha o en el carrito.
   ================================================================== */
(function(){
  var CX2 = {};
  try{ CX2 = JSON.parse(document.getElementById("pc-conexion").textContent) || {}; }catch(e){ return; }
  var P100X = CX2.precios || {}, P50X = CX2.precios50 || {};
  function norm(s){ return String(s||"").normalize("NFD").replace(/[\u0300-\u036f]/g,"").toLowerCase().replace(/[^a-z0-9]+/g," ").trim(); }
  var P100N = {}, P50N = {};
  Object.keys(P100X).forEach(function(k){ P100N[norm(k)] = P100X[k]; });
  Object.keys(P50X).forEach(function(k){ P50N[norm(k)] = P50X[k]; });
  function precio(X, N, n){
    var t = String(n||"").trim();
    if(X[t] != null) return +X[t];
    /* Si el nombre exacto existe en el mapa (es un producto propio, p. ej. el
       ambiental «Santal 33»), no se adivina con el normalizado: eso le
       colgaria el 50 ml del perfume «SANTAL 33». */
    if(P100X[t] != null) return null;
    var v = N[norm(t)]; return v == null ? null : +v; }
  function mx(n){ return "$" + Number(n).toLocaleString("es-MX"); }
  function pintar(){
    var cajas = document.querySelectorAll(".card[data-name] .price:not([data-2p]), .cat-card[data-name] .price:not([data-2p]), .cat-card[data-name] .cat-price:not([data-2p]), .pp-simcard[data-name] .pr:not([data-2p]), .nz-card[data-name] .nz-price:not([data-2p])"); /* 4-sep: catalogo, similares y novedades */
    for(var i = 0; i < cajas.length; i++){
      var pr = cajas[i], card = pr.closest("[data-name]"); if(!card) continue;
      var n = card.dataset.name, p50 = precio(P50X, P50N, n); if(p50 == null){ pr.setAttribute("data-2p", "no"); continue; }
      var p100 = precio(P100X, P100N, n);
      if(p100 == null){ var m = /\$\s?([\d,\.]+)/.exec(pr.textContent||""); p100 = m ? Number(m[1].replace(/,/g,"")) : null; }
      if(p100 == null){ pr.setAttribute("data-2p", "no"); continue; }
      pr.setAttribute("data-2p", "1");
      /* 4-sep (la casa): 50 ml resaltado a la izquierda, 100 ml a la derecha */
      pr.innerHTML = '<span class="pz pz-50"><i>50 ml</i><b>' + mx(p50) + '</b></span>' +
                     '<span class="pz pz-100"><i>100 ml</i><b>' + mx(p100) + '</b></span>';
    }
  }
  var t = null;
  function programar(){ clearTimeout(t); t = setTimeout(pintar, 40); }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", programar); else programar();
  new MutationObserver(programar).observe(document.body, {childList:true, subtree:true});
  window.addEventListener("hashchange", programar);
})();

/* ==================================================================
   TARJETAS HOMOLOGADAS (4-sep-2026, comentarios 1-4 de la casa)

   Cuatro tipos de tarjeta ensenaban el perfume de cuatro formas. Ahora
   todas dicen lo mismo: el codigo (si lo hay), «Inspirado en Nombre · Casa»
   y los dos precios. El nombre suelto se oculta porque ya va dentro del
   «Inspirado en», y el «● Disponible» se retira: lo que no esta disponible
   simplemente no se muestra. Los precios NO se tocan aqui: los pone el
   doble precio de arriba y el corrector de index-44, desde el mapa.
   ================================================================== */
(function(){
  var TIPOS = [
    {sel: ".card[data-name]",       nombre: "h3", insp: ".insp",      stock: null},
    {sel: ".cat-card[data-name]",   nombre: "h3", insp: ".cat-house", stock: ".cat-stock"},
    {sel: ".pp-simcard[data-name]", nombre: "h4", insp: ".insp",      stock: null},
    {sel: ".nz-card[data-name]",    nombre: "h3", insp: ".nz-fam",    stock: null}
  ];
  var CASA = {};
  (window.VELANTIS_CAT || []).forEach(function(f){ if(f && f[0] && f[2]) CASA[f[0]] = f[2]; });
  function bonito(n){
    return String(n || "").split(/\s+/).map(function(w){
      if(/\d/.test(w) || /^[A-Z&]{1,2}$/.test(w)) return w;            /* «9 PM», «L.12.12», «CH» se quedan */
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    }).join(" ");
  }
  function casaDe(txt){
    var m = /Inspirado en\s*·?\s*(.*)$/i.exec(txt || ""); if(!m) return "";
    var r = m[1]; if(r.indexOf("·") >= 0) r = r.split("·").pop(); return r.trim();
  }
  function pasar(){
    for(var t = 0; t < TIPOS.length; t++){
      var T = TIPOS[t], cards = document.querySelectorAll(T.sel + ":not([data-homolog])");
      for(var i = 0; i < cards.length; i++){
        var c = cards[i]; c.setAttribute("data-homolog", "1");
        if(/^AMB:/.test(c.dataset.lhs || "") || /aroma de ambiente|aceite|difusor/i.test(c.dataset.sub || "")) continue;
        var n = c.dataset.name, ins = c.querySelector(T.insp), h = c.querySelector(T.nombre);
        var casa = (ins && casaDe(ins.textContent)) || CASA[n] || "";
        if(ins){ var kick = c.querySelector(".cat-kicker"); ins.textContent = (kick ? "" : "Inspirado en ") + bonito(n) + (casa ? " · " + casa : ""); ins.classList.add("h-insp"); }
        if(h && ins) h.classList.add("h-oculto");
        if(T.stock){ var st = c.querySelector(T.stock); if(st) st.remove(); }
      }
    }
  }
  var t = null;
  function programar(){ clearTimeout(t); t = setTimeout(pasar, 50); }
  if(document.readyState === "loading") document.addEventListener("DOMContentLoaded", programar); else programar();
  new MutationObserver(programar).observe(document.body, {childList: true, subtree: true});
  window.addEventListener("hashchange", programar);
})();
